<h3>Sie können die Vorlagen und Checklisten herunterladen, ausdrucken und per E-mail weiterleiten.</h3>

@for (template of templates(); track template) {
  <a
    matButton="filled"
    color="accent"
    class="container-item button-rounded"
    [href]="template.url"
    target="_blank"
    (click)="openTemplate($event, template)">
    <div class="container-text">
      <div class="text-title">
        {{ template.title }}
      </div>
    </div>
  </a>
}
